import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { RequestInterceptor } from '../types';
import { getSessionOutHeader } from '../../utils/headers';
import { reportCacheCGIData, reportCGIData, reportUrlData } from './util';
import { LOGIN_MAX_DURATION } from '../../utils/check-login';

/**
 * 检测登陆是否失效
 * @param config
 * @returns
 */
function checkSessionOut(config: AxiosRequestConfig) {
  return getSessionOutHeader(config) === '1';
}

/**
 * 对请求做日志上报
 */
export default class ReportRequestInterceptor implements RequestInterceptor {
  /** 是否登陆失效标识 */
  isSessionOut = false;

  constructor() {
    // 上报上次缓存的请求上报
    setTimeout(reportCacheCGIData, LOGIN_MAX_DURATION);
  }

  /**
   * 处理请求信息
   * @param config
   * @returns
   */
  handleRequest(config: AxiosRequestConfig) {
    console.log(config.url,  'report');
    // 对因登陆失效而被取消的请求做上报
    if (this.isSessionOut) {
      setTimeout(() => {
        reportUrlData(config);
      });
    }
    return config;
  }

  /**
   * 处理响应信息
   * @param response
   * @returns
   */
  handleResponse(response: AxiosResponse) {
    const { config } = response;
    const isSessionOut = checkSessionOut(config);
    // 先只上报登陆超时时的CGI请求日志
    if (isSessionOut) {
      this.isSessionOut = true;
      reportCGIData(response, true);
    }
    return response;
  }
}
